(function ($) {
	class ULPC {
		// Static properties
		static PREGNANCY_DEFAULTS = {
			FULL_TERM_WEEKS: 40,
			FULL_TERM_DAYS: 280, // 40 weeks * 7 days
			MIN_TERM_WEEKS: 37, // Minimum term for full-term pregnancy
			MAX_TERM_WEEKS: 42, // Maximum term for normal pregnancy
			DAYS_PER_MONTH: 30.41, // Average days in month
			DAYS_PER_YEAR: 365.25, // Days in year including leap years
			OVULATION_OFFSET: 14, // Days from period start to ovulation
			PREGNANCY_FROM_OVULATION: 266, // Days from ovulation to birth
		};

		constructor(element) {
			this.element = element;
			this.widgetClass = ".ultimate-pregnancy-ovulation-calculator";
			this.result = {};
			this.data = {};
			this.calculatorID = $(element).attr("id");
		}

		init() {
			const calculator = $(this.element);

			this.setCurrentDate();
			this.dateInit();
			this.setCalculatorData();
			this.selectInit();
			this.customNumberInputInit();
			this.setCssVariables();
			this.showHelp();
			this.changeOptions();
			this.calculateResult();

			if (calculator.length && !$("body").hasClass("ultimate-pregnancy-ovulation-calculator-page")) {
				$("body").addClass("ultimate-pregnancy-ovulation-calculator-page");
			}
		}

		setCurrentDate() {
			const calculator = $(this.widgetClass);
			this.data.calculatorMethod = calculator.find(".ulpc_calculator_method").val();

			let initialDate = new Date();
			const today = new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate(), 0, 0, 1);
			this.today = today;

			switch (this.data.calculatorMethod) {
				case "due_date":
					initialDate.setDate(initialDate.getDate() + 240);
					break;
				default:
					initialDate.setDate(initialDate.getDate() - 14);
					break;
			}
			initialDate = new Date(initialDate.getFullYear(), initialDate.getMonth(), initialDate.getDate(), 0, 0, 1);
			this.initialDate = initialDate;
		}

		dateInit() {
			const calculator = $(this.element);

			const ulpc = this;

			this.data.dateFormat = calculator.attr("data-date-format");
			const formattedDate = $.datepicker.formatDate(this.data.dateFormat, this.initialDate);

			calculator.find(".ulpc-input__date").val(formattedDate);
			this.data.today = formattedDate;

			const defaultDatepickerSettings = {
				dateFormat: this.data.dateFormat,
				defaultDate: this.today,
				beforeShow: function (input, inst) {
					$("#ui-datepicker-div").addClass("ulpc-datepicker");
				},
				onSelect: function (dateText, inst) {
					ulpc.setCalculatorData();
					ulpc.calculateResult();
				},
			};

			calculator.find(".ulpc-input__date").each(function () {
				const $input = $(this);
				let settings = { ...defaultDatepickerSettings };

				if ($input.hasClass("ulpc_last_period")) {
					settings.maxDate = ulpc.today;
					settings.defaultDate = ulpc.initialDate;
					$input.val($.datepicker.formatDate(ulpc.data.dateFormat, ulpc.initialDate));
				}

				$input.datepicker(settings);
			});
		}

		customNumberInputInit() {
			const calculator = $(this.element);
			if ($.fn.numberstyle) {
				if (calculator.find(".ulpc_cycle_length").length) {
					calculator.find(".ulpc_cycle_length").numberstyle();
				}
			}
		}

		setCalculatorData() {
			const calculator = $(this.element);

			this.data.calculatorMethod = calculator.find(".ulpc_calculator_method").val();
			this.data.dueDate = calculator.find(".ulpc_due_date").length ? calculator.find(".ulpc_due_date").datepicker("getDate") : "";
			this.data.lastPeriodDate = calculator.find(".ulpc_last_period").length ? calculator.find(".ulpc_last_period").datepicker("getDate") : "";
			this.data.cycleLength = calculator.find(".ulpc_cycle_length").val() ? +calculator.find(".ulpc_cycle_length").val() : "";
			this.data.acceptance = +calculator.find("[name=ulpc_user_acceptance]").val();
		}

		selectInit() {
			if ($.fn.customSelect) {
				const ulpc = this;
				const calculator = $(this.element);

				calculator.find(".ulpc_calculator_method").customSelect({
					block: "ulpc-select",
					includeValue: true,
					hideCallback: function () {
						var $value = calculator.find(".ulpc_calculator_method").val();
						calculator.find(".ulpc-settings__section").hide();
						setTimeout(() => {
							$(`#ulpc_${$value}_settings_${calculator.attr("id")}`).show();
						}, 100);

						ulpc.setCalculatorData();
						ulpc.calculateResult();
					},
				});
			}
		}

		changeOptions() {
			const ulpc = this;
			const calculator = $(this.element);

			calculator.find(".ulpc-settings").on("change", "input", function () {
				ulpc.setCalculatorData();
				ulpc.calculateResult();
			});

			calculator.find(".ulpc_calculator_method").on("select2:select", function (e) {
				var data = e.params.data;
				calculator.find(".ulpc_calculator_method").val(data.id);
				ulpc.setCalculatorData();
				ulpc.calculateResult();
			});
		}

		calculateResult() {
			const data = this.data;
			const calculatorType = $(this.element).data("calculator-type");
			let result = {};

			this.result = {};

			if (calculatorType === "ovulation") {
				if (data.lastPeriodDate && data.cycleLength) {
					this.result = this.calculateOvulationDetails(data.lastPeriodDate, data.cycleLength, this.today);
				} else {
					this.result = {
						error: ulpc_vars.i18n.emptyLastPeriodDate,
					};
				}
			} else if (calculatorType === "pregnancy") {
				switch (data.calculatorMethod) {
					case "due_date":
						if (data.dueDate) {
							// Set time to midnight to avoid timezone issues
							const dueDate = new Date(data.dueDate.getFullYear(), data.dueDate.getMonth(), data.dueDate.getDate(), 0, 0, 1);
							this.result = this.calculatePregnancyDetails(dueDate, this.today, true);
						} else {
							this.result = {
								pregnant: false,
								babyAge: {},
								error: ulpc_vars.i18n.emptyDueDate,
							};
						}
						break;
					case "last_period":
						if (data.lastPeriodDate) {
							// Calculate ovulation date
							const ovulationDate = new Date(data.lastPeriodDate);
							ovulationDate.setDate(ovulationDate.getDate() + (data.cycleLength - ULPC.PREGNANCY_DEFAULTS.OVULATION_OFFSET));

							// Calculate due date
							const dueDate = new Date(ovulationDate);
							dueDate.setDate(ovulationDate.getDate() + ULPC.PREGNANCY_DEFAULTS.PREGNANCY_FROM_OVULATION);

							// Calculate conception date
							const conceptionDate = new Date(ovulationDate);

							// Calculate days since ovulation
							const daysSinceOvulation = this.diffCalendarDays(this.today, ovulationDate);

							// Calculate days since last period
							const daysSinceLastPeriod = this.diffCalendarDays(this.today, data.lastPeriodDate);
							const cycleDay = daysSinceLastPeriod + 1;

							// Calculate next period date
							const nextPeriodDate = new Date(data.lastPeriodDate);
							nextPeriodDate.setDate(nextPeriodDate.getDate() + data.cycleLength);

							// Check if before next period
							const isBeforeNextPeriod = this.today < nextPeriodDate;

							// Check if future pregnancy
							if (this.today < ovulationDate || daysSinceOvulation < 7 || this.today < nextPeriodDate) {
								result = {
									pregnant: false,
									babyAge: {},
									pregnantDays: 0,
									currentWeek: 0,
									pregnantWeeksDays: { weeks: 0, days: 0 },
									pregnantMonthsDays: { months: 0, days: 0 },
									pregnancyRemainingDays: ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS,
									futurePregnancy: true,
									estimatedConceptionDate: conceptionDate,
									daysUntilConception: Math.max(0, this.diffCalendarDays(ovulationDate, this.today)),
									dueDate: dueDate,
									conceptionDate: conceptionDate,
									ovulationDate: ovulationDate,
									daysSinceLastPeriod: daysSinceLastPeriod,
									cycleDay: cycleDay,
									nextPeriodDate: nextPeriodDate,
									isBeforeNextPeriod: isBeforeNextPeriod,
								};
							} else {
								// Calculate days since conception
								const daysSinceConception = new Date(ovulationDate);
								const pregnantDays = Math.max(0, this.diffCalendarDays(this.today, daysSinceConception));

								if (pregnantDays > 0) {
									result = this.calculatePregnancyDetails(dueDate, this.today, false);
									result.ovulationDate = ovulationDate;
									result.daysSinceLastPeriod = daysSinceLastPeriod;
									result.cycleDay = cycleDay;
									result.nextPeriodDate = nextPeriodDate;
									result.pregnantDays = pregnantDays;
									result.currentWeek = Math.floor(pregnantDays / 7) + 1;
									result.pregnantWeeksDays = this.calculateWeeksDays(pregnantDays);
									result.pregnantMonthsDays = this.calculateMonthsDays(pregnantDays);
									result.gestationalDays = daysSinceLastPeriod;
									result.gestationalAge = {
										weeks: Math.floor(daysSinceLastPeriod / 7),
										days: daysSinceLastPeriod % 7,
									};
								} else {
									result = {
										pregnant: false,
										babyAge: {},
										pregnantDays: 0,
										currentWeek: 0,
										pregnantWeeksDays: { weeks: 0, days: 0 },
										pregnantMonthsDays: { months: 0, days: 0 },
										pregnancyRemainingDays: ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS,
										futurePregnancy: true,
										estimatedConceptionDate: conceptionDate,
										daysUntilConception: 0,
										dueDate: dueDate,
										conceptionDate: conceptionDate,
										ovulationDate: ovulationDate,
										daysSinceLastPeriod: daysSinceLastPeriod,
										cycleDay: cycleDay,
										nextPeriodDate: nextPeriodDate,
										isBeforeNextPeriod: isBeforeNextPeriod,
									};
								}
							}

							this.result = result;
						} else {
							this.result = {
								pregnant: false,
								babyAge: {},
								error: ulpc_vars.i18n.emptyLastPeriodDate,
							};
						}
						break;
				}
			}

			this.displayResult();
		}

		calculatePregnancyDetails(dueDate, currentDate, preserveExactDueDate = false) {
			const result = {};
			let maxAllowedDueDate = new Date(currentDate);
			maxAllowedDueDate.setDate(currentDate.getDate() + ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS);

			// If we need to preserve the exact due date, create a new date with midnight time
			// This eliminates timezone issues when converting to JSON
			if (preserveExactDueDate) {
				// Create a new date with midnight time on the same day
				maxAllowedDueDate = new Date(maxAllowedDueDate.getFullYear(), maxAllowedDueDate.getMonth(), maxAllowedDueDate.getDate(), 0, 0, 1);
				dueDate = new Date(dueDate.getFullYear(), dueDate.getMonth(), dueDate.getDate(), 0, 0, 1);
			}

			// Calculate conception date based on due date
			let conceptionDate = new Date(dueDate);
			conceptionDate = new Date(conceptionDate.getFullYear(), conceptionDate.getMonth(), conceptionDate.getDate(), 0, 0, 1);
			conceptionDate.setDate(conceptionDate.getDate() - ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS);

			// Calculate LMP (Last Menstrual Period) date - typically 2 weeks before conception
			let lmpDate = new Date(conceptionDate);
			lmpDate = new Date(lmpDate.getFullYear(), lmpDate.getMonth(), lmpDate.getDate(), 0, 0, 1);
			lmpDate.setDate(conceptionDate.getDate() - 14);

			// Calculate days since LMP
			const daysSinceLMP = this.diffCalendarDays(currentDate, lmpDate);

			if (dueDate > maxAllowedDueDate) {
				result.pregnant = false;
				result.babyAge = {};
				result.pregnantDays = 0;
				result.currentWeek = 0;
				result.pregnantWeeksDays = { weeks: 0, days: 0 };
				result.pregnantMonthsDays = { months: 0, days: 0 };
				result.pregnancyRemainingDays = ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS;
				result.futurePregnancy = true;
				result.estimatedConceptionDate = conceptionDate;
				result.daysUntilConception = this.diffCalendarDays(conceptionDate, currentDate) + 1;
			} else if (dueDate.getTime() === maxAllowedDueDate.getTime()) {
				result.pregnant = false;
				result.babyAge = {};
				result.pregnantDays = 0;
				result.currentWeek = 0;
				result.pregnantWeeksDays = { weeks: 0, days: 0 };
				result.pregnantMonthsDays = { months: 0, days: 0 };
				result.pregnancyRemainingDays = ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS;
				result.futurePregnancy = true;
				result.estimatedConceptionDate = conceptionDate;
				result.daysUntilConception = this.diffCalendarDays(conceptionDate, currentDate) + 1;
			} else if (dueDate >= currentDate) {
				// Check if conception date is in the future
				if (conceptionDate >= currentDate) {
					// Future conception date means no pregnancy yet
					result.pregnant = false;
					result.babyAge = {};
					result.pregnantDays = 0;
					result.currentWeek = 0;
					result.pregnantWeeksDays = { weeks: 0, days: 0 };
					result.pregnantMonthsDays = { months: 0, days: 0 };
					result.pregnancyRemainingDays = ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS;
					result.futurePregnancy = true;
					result.estimatedConceptionDate = conceptionDate;
					result.daysUntilConception = this.diffCalendarDays(conceptionDate, currentDate) + 1;
				} else {
					// Calculate pregnancy days from conception date
					const pregnancyDays = Math.max(0, this.diffCalendarDays(currentDate, conceptionDate));

					// Calculate gestational age (from LMP, which is typically 2 weeks before conception)
					// Note: This will be overridden for last_period method in the calling function
					const gestationalDays = pregnancyDays + 14; // Add 2 weeks (14 days)
					const gestationalWeeks = Math.floor(gestationalDays / 7);
					const gestationalRemainingDays = gestationalDays % 7;

					result.pregnant = true;
					result.babyAge = {};
					result.pregnantDays = pregnancyDays;
					result.currentWeek = Math.floor(pregnancyDays / 7) + 1;
					result.pregnantWeeksDays = this.calculateWeeksDays(pregnancyDays);
					result.pregnantMonthsDays = this.calculateMonthsDays(pregnancyDays);
					result.pregnancyRemainingDays = ULPC.PREGNANCY_DEFAULTS.FULL_TERM_DAYS - pregnancyDays;

					// Add gestational age information (medical standard)
					result.gestationalDays = gestationalDays;
					result.gestationalAge = {
						weeks: gestationalWeeks,
						days: gestationalRemainingDays,
					};

					// Calculate trimesters based on LMP (Last Menstrual Period)
					const firstTrimesterStart = new Date(lmpDate);
					const firstTrimesterEnd = new Date(firstTrimesterStart);
					firstTrimesterEnd.setDate(firstTrimesterStart.getDate() + 13 * 7); // 13 weeks from LMP

					const secondTrimesterStart = new Date(firstTrimesterEnd);
					secondTrimesterStart.setDate(firstTrimesterEnd.getDate() + 1);
					const secondTrimesterEnd = new Date(firstTrimesterStart);
					secondTrimesterEnd.setDate(firstTrimesterStart.getDate() + 26 * 7); // 26 weeks from LMP

					const thirdTrimesterStart = new Date(secondTrimesterEnd);
					thirdTrimesterStart.setDate(secondTrimesterEnd.getDate() + 1);
					const thirdTrimesterEnd = new Date(dueDate);

					result.trimesters = {
						first: {
							start: firstTrimesterStart,
							end: firstTrimesterEnd,
							progress: this.calculateTrimesterProgress(currentDate, firstTrimesterStart, firstTrimesterEnd),
						},
						second: {
							start: secondTrimesterStart,
							end: secondTrimesterEnd,
							progress: this.calculateTrimesterProgress(currentDate, secondTrimesterStart, secondTrimesterEnd),
						},
						third: {
							start: thirdTrimesterStart,
							end: thirdTrimesterEnd,
							progress: this.calculateTrimesterProgress(currentDate, thirdTrimesterStart, thirdTrimesterEnd),
						},
					};

					// Calculate current trimester
					if (currentDate <= firstTrimesterEnd) {
						result.currentTrimester = 1;
						result.currentTrimesterProgress = result.trimesters.first.progress;
					} else if (currentDate <= secondTrimesterEnd) {
						result.currentTrimester = 2;
						result.currentTrimesterProgress = result.trimesters.second.progress;
					} else {
						result.currentTrimester = 3;
						result.currentTrimesterProgress = result.trimesters.third.progress;
					}
				}
			} else {
				result.pregnant = false;
				result.babyAge = this.calculateBabyAge(currentDate, dueDate);
			}

			result.conceptionDate = conceptionDate;
			result.dueDate = dueDate;
			result.lmpDate = lmpDate;
			result.daysSinceLMP = daysSinceLMP;
			return result;
		}

		getUTCDayNumber(date) {
			return Math.floor(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / (1000 * 60 * 60 * 24));
		}

		diffCalendarDays(dateA, dateB) {
			return this.getUTCDayNumber(dateA) - this.getUTCDayNumber(dateB);
		}

		calculateWeeksDays(totalDays) {
			return {
				weeks: Math.floor(totalDays / 7),
				days: Math.floor(totalDays % 7),
			};
		}

		calculateMonthsDays(totalDays) {
			return {
				months: Math.floor(totalDays / ULPC.PREGNANCY_DEFAULTS.DAYS_PER_MONTH),
				days: Math.floor(totalDays % ULPC.PREGNANCY_DEFAULTS.DAYS_PER_MONTH),
			};
		}

		calculateBabyAge(currentDate, birthDate) {
			const ageDays = this.diffCalendarDays(currentDate, birthDate);

			if (ageDays < 30) {
				return {
					format: "weeks",
					...this.calculateWeeksDays(ageDays),
				};
			} else if (ageDays < ULPC.PREGNANCY_DEFAULTS.DAYS_PER_YEAR) {
				return {
					format: "months",
					...this.calculateMonthsDays(ageDays),
				};
			} else {
				const years = Math.floor(ageDays / ULPC.PREGNANCY_DEFAULTS.DAYS_PER_YEAR);
				const remainingDays = ageDays % ULPC.PREGNANCY_DEFAULTS.DAYS_PER_YEAR;
				return {
					format: "years",
					years: years,
					months: Math.floor(remainingDays / ULPC.PREGNANCY_DEFAULTS.DAYS_PER_MONTH),
				};
			}
		}

		displayResult() {
			const calculator = $(this.element);
			const result = this.result;
			const calculatorType = calculator.data("calculator-type");
			let html = "";

			if (calculatorType === "ovulation") {
				if (!result.error) {
					// Prepare result for PHP - ensure all dates are formatted
					const preparedResult = this.prepareResultForPHP(result);

					// Send AJAX request
					const data = {
						action: "ulpc_get_ovulation_results",
						nonce: $("#ulpc_nonce_" + this.calculatorID).val(),
						result: JSON.stringify(preparedResult),
						calculator_data: JSON.stringify(this.data),
					};

					$.ajax({
						url: window.ulpc_vars.ajaxurl,
						type: "POST",
						data: data,
						success: (response) => {
							if (response.success && response.data) {
								html = response.data.html;
								calculator.find(".ulpc-result__data-result").empty().html(html);

								setTimeout(() => {
									this.initOvulationCalendar(result);
								}, 0);
							}
						},
						error: (xhr, status, error) => {
							console.error("Error getting ovulation results:", error);
						},
					});
					return;
				} else {
					html = this.displayCalculatorError(result);
				}
				return;

				if (result.error) {
					html = this.displayCalculatorError(result);
				} else {
					html = this.displayOvulationResults(result);
					setTimeout(() => {
						this.initOvulationCalendar(result);
					}, 0);
				}
			} else if (calculatorType === "pregnancy") {
				if (!result.error) {
					// Prepare result for PHP - ensure all dates are formatted
					const preparedResult = this.prepareResultForPHP(result);

					// Send AJAX request
					const data = {
						action: "ulpc_get_pregnancy_results",
						nonce: $("#ulpc_nonce_" + this.calculatorID).val(),
						result: JSON.stringify(preparedResult),
						calculator_data: JSON.stringify(this.data),
					};

					$.ajax({
						url: window.ulpc_vars.ajaxurl,
						type: "POST",
						data: data,
						success: (response) => {
							if (response.success && response.data) {
								html = response.data.html;
								calculator.find(".ulpc-result__data-result").empty().html(html);
							}
						},
						error: (xhr, status, error) => {
							console.error("Error getting pregnancy results:", error);
						},
					});
					return;
				} else {
					html = this.displayCalculatorError(result);
				}
			}

			calculator.find(".ulpc-result__data-result").empty().html(html);
		}

		displayCalculatorError(result) {
			return `<p class="ulpc-result__data-error">${result.error}</p>`;
		}

		displayOvulationResults(result) {
			const currentCycle = result.currentCycle;
			const dateFormat = this.data.dateFormat;
			let html = '<div class="ulpc-result__ovulation-results">';

			// Current cycle information
			html += '<div class="ulpc-result__ovulation-current">';
			html += "<h4 class='ulpc-result__data-subtitle'>Current Cycle Details</h4>";
			html += `<p><span class="ulpc-result__ovulation-legend ulpc-result__ovulation-legend--fertile"></span>Fertile Window: ${$.datepicker.formatDate(dateFormat, currentCycle.fertileWindowStart)} - ${$.datepicker.formatDate(dateFormat, currentCycle.fertileWindowEnd)}</p>`;
			html += `<p><span class="ulpc-result__ovulation-legend ulpc-result__ovulation-legend--ovulation"></span>Most Probable Ovulation Date: ${$.datepicker.formatDate(dateFormat, currentCycle.ovulationDate)}</p>`;
			html += `<p><span class="ulpc-result__ovulation-legend ulpc-result__ovulation-legend--pregnancy-test"></span>Pregnancy Test Date: ${$.datepicker.formatDate(dateFormat, currentCycle.pregnancyTestDate)}</p>`;
			html += `<p><span class="ulpc-result__ovulation-legend ulpc-result__ovulation-legend--period"></span>Next Period Start: ${$.datepicker.formatDate(dateFormat, currentCycle.nextPeriodStart)}</p>`;
			html += "</div>";

			// Cycles table
			html += '<div class="ulpc-result__ovulation-cycles">';
			html += "<h4 class='ulpc-result__data-subtitle'>Next 6 Cycles</h4>";
			html += '<table class="ulpc-table">';
			html += "<thead><tr><th>Period Start</th><th>Fertile Window</th><th>Estimated Due Date</th></tr></thead>";
			html += "<tbody>";

			result.cycles.forEach((cycle) => {
				html += "<tr>";
				html += `<td>${$.datepicker.formatDate(dateFormat, cycle.periodStart)}</td>`;
				html += `<td>${$.datepicker.formatDate(dateFormat, cycle.fertileWindowStart)} - ${$.datepicker.formatDate(dateFormat, cycle.fertileWindowEnd)}</td>`;
				html += `<td>${$.datepicker.formatDate(dateFormat, cycle.estimatedDueDate)}</td>`;
				html += "</tr>";
			});

			html += "</tbody></table>";
			html += "</div>";

			return html;
		}

		initOvulationCalendar(result) {
			const calculator = $(this.element);
			const calendarEl = calculator.find(".ulpc-result__ovulation-calendar");
			const today = new Date(); // Get today's date
			const ulpc = this; // Store reference to this for use in callbacks

			if (!calendarEl.length || !result.cycles || !result.cycles.length) {
				return;
			}

			if (calendarEl.hasClass("hasDatepicker")) {
				calendarEl.datepicker("destroy");
			}

			// Set min and max dates for 6 months range
			const minDate = result.cycles[0].periodStart;
			const maxDate = result.cycles[5].nextPeriodStart;

			// Function to determine number of months based on container width
			const getNumberOfMonths = () => {
				// Get the width of the container that holds the calculator
				const containerWidth = calculator.parent().width();
				return containerWidth < 700 ? 1 : [1, 2];
			};

			// Initialize datepicker
			calendarEl.datepicker({
				dateFormat: this.data.dateFormat,
				numberOfMonths: getNumberOfMonths(),
				minDate: minDate,
				maxDate: maxDate,
				beforeShowDay: (date) => this.highlightOvulationDates(date, result),
				onSelect: function (dateText, inst) {
					// Get the selected date and update visual data
					const selectedDate = calendarEl.datepicker("getDate");
					ulpc.getVisualData(selectedDate, result);
					return false;
				},
			});

			// Set today's date as the default selected date
			calendarEl.datepicker("setDate", today);

			// Get visual data for the initial date (today)
			this.getVisualData(today, result);

			// Handle window resize
			const resizeHandler = () => {
				// Store the current date to restore it after refresh
				const currentDate = calendarEl.datepicker("getDate");

				// Destroy and reinitialize datepicker with new number of months
				calendarEl.datepicker("destroy");
				calendarEl.datepicker({
					dateFormat: this.data.dateFormat,
					numberOfMonths: getNumberOfMonths(),
					minDate: minDate,
					maxDate: maxDate,
					beforeShowDay: (date) => this.highlightOvulationDates(date, result),
					onSelect: function (dateText, inst) {
						const selectedDate = calendarEl.datepicker("getDate");
						ulpc.getVisualData(selectedDate, result);
						return false;
					},
				});

				// Restore the previously selected date
				calendarEl.datepicker("setDate", currentDate);
			};

			// Debounce function to limit how often the resize event fires
			const debounce = (func, delay) => {
				let timeoutId;
				return function () {
					const context = this;
					const args = arguments;
					clearTimeout(timeoutId);
					timeoutId = setTimeout(() => {
						func.apply(context, args);
					}, delay);
				};
			};

			// Add resize event listener with debounce
			const debouncedResizeHandler = debounce(resizeHandler, 250);
			$(window).on("resize.ulpcCalendar_" + this.calculatorID, debouncedResizeHandler);

			// Clean up event listener when calendar is destroyed
			calendarEl.on("remove", function () {
				$(window).off("resize.ulpcCalendar_" + ulpc.calculatorID);
			});
		}
		getVisualData(currentDate, result) {
			const calculator = $(this.element);
			const currentPhaseArray = this.highlightOvulationDates(currentDate, result);
			const currentPhase = currentPhaseArray[3];

			// Calculate cycle day for the selected date
			let cycleDay = 0;

			// Find which cycle the selected date belongs to
			for (const cycle of result.cycles) {
				const periodStart = new Date(cycle.periodStart.getFullYear(), cycle.periodStart.getMonth(), cycle.periodStart.getDate());
				const nextPeriodStart = new Date(cycle.nextPeriodStart.getFullYear(), cycle.nextPeriodStart.getMonth(), cycle.nextPeriodStart.getDate());

				// If date is within this cycle
				if (currentDate >= periodStart && currentDate < nextPeriodStart) {
					// Calculate days since period start (cycle day)
					const daysSincePeriodStart = Math.floor((currentDate - periodStart) / (1000 * 60 * 60 * 24));
					cycleDay = daysSincePeriodStart + 1; // +1 because day 1 is the first day of period
					break;
				}
			}

			// Send AJAX request
			const data = {
				action: "ulpc_get_ovulation_visual_data",
				nonce: $("#ulpc_nonce_" + this.calculatorID).val(),
				calculator_id: this.calculatorID,
				current_date: $.datepicker.formatDate(this.data.dateFormat, currentDate),
				current_phase: currentPhase,
				cycle_day: cycleDay,
			};

			$.ajax({
				url: window.ulpc_vars.ajaxurl,
				type: "POST",
				data: data,
				success: (response) => {
					if (response.success && response.data) {
						const html = response.data.html;
						calculator.find(".ulpc-result__ovulation-visual-data").empty().html(html);
					}
				},
				error: (xhr, status, error) => {
					console.error("Error getting ovulation results:", error);
				},
			});
		}

		highlightOvulationDates(date, result) {
			// Convert date to midnight for comparison
			const currentDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
			let cssClass = "";
			let tooltip = "";
			let phase = "luteal";

			// Check each cycle
			for (const cycle of result.cycles) {
				// Convert all dates to midnight for comparison
				const periodStart = new Date(cycle.periodStart.getFullYear(), cycle.periodStart.getMonth(), cycle.periodStart.getDate());
				const periodEnd = new Date(periodStart);
				periodEnd.setDate(periodStart.getDate() + 4); // 5 days total

				const fertileStart = new Date(cycle.fertileWindowStart.getFullYear(), cycle.fertileWindowStart.getMonth(), cycle.fertileWindowStart.getDate());
				const fertileEnd = new Date(cycle.fertileWindowEnd.getFullYear(), cycle.fertileWindowEnd.getMonth(), cycle.fertileWindowEnd.getDate());
				const ovulationDate = new Date(cycle.ovulationDate.getFullYear(), cycle.ovulationDate.getMonth(), cycle.ovulationDate.getDate());
				const pregnancyTestDate = new Date(cycle.pregnancyTestDate.getFullYear(), cycle.pregnancyTestDate.getMonth(), cycle.pregnancyTestDate.getDate());

				if (currentDate.getTime() === pregnancyTestDate.getTime()) {
					cssClass = "ulpc-pregnancy-test-day";
					tooltip = ulpc_vars.i18n.pregnancyTestDay;
					phase = "pregnancy-test";
					return [true, cssClass, tooltip, phase];
				}

				if (currentDate.getTime() === ovulationDate.getTime()) {
					cssClass = "ulpc-ovulation-day";
					tooltip = ulpc_vars.i18n.ovulationDay;
					phase = "ovulation";
					return [true, cssClass, tooltip, phase];
				}

				if (currentDate >= fertileStart && currentDate <= fertileEnd) {
					cssClass = "ulpc-fertile-day";
					tooltip = ulpc_vars.i18n.fertileWindow;
					phase = "fertile";
					return [true, cssClass, tooltip, phase];
				}

				if (currentDate >= periodStart && currentDate <= periodEnd && !cssClass) {
					cssClass = "ulpc-period-day";
					tooltip = ulpc_vars.i18n.period;
					phase = "menstrual";
					return [true, cssClass, tooltip, phase];
				}
			}

			return [true, cssClass, tooltip, phase];
		}

		isDateInRange(date, startDate, days) {
			const endDate = new Date(startDate);
			endDate.setDate(startDate.getDate() + days - 1);
			return date >= startDate && date <= endDate;
		}

		isDateBetween(date, startDate, endDate) {
			return date >= startDate && date <= endDate;
		}

		isSameDate(date1, date2) {
			return date1.toISOString().split("T")[0] === date2.toISOString().split("T")[0];
		}

		getBabySize(week, calculator) {
			const calculationMethod = this.calculationMethod;

			const data = {
				action: "ulpc_get_baby_size",
				week: week,
				method: calculationMethod,
				nonce: $("#ulpc_nonce_" + this.calculatorID).val(),
			};

			$.ajax({
				url: window.ulpc_vars.ajaxurl,
				type: "POST",
				data: data,
				success: (response) => {
					if (response.success && response.data) {
						const babySize = response.data;
						const babySizeHTML = `
							<div class="ulpc-result__baby-size">
								<div class="ulpc-result__baby-size-image">
									<img src="${babySize.image}" alt="${babySize.name}" />
								</div>
								<p class="ulpc-result__baby-size-name">${babySize.name}</p>
								<p class="ulpc-result__baby-size-description">${babySize.description}</p>
							</div>
						`;

						// Insert baby size info after pregnancy status
						calculator.find(".ulpc-result__data-test p:first").after(babySizeHTML);
					}
				},
				error: (xhr, status, error) => {
					console.error("Error getting baby size:", error);
				},
			});
		}

		animateCounter(element, value) {
			if (element.length && value && value > 0) {
				jQuery({ Counter: 0 }).animate(
					{ Counter: value },
					{
						duration: 400,
						easing: "swing",
						step: function (now) {
							element.text(Math.ceil(now));
						},
						done: function () {
							element.text(this.Counter);
						},
					}
				);
			}
		}

		showHelp() {
			const calculator = $(this.element);

			calculator.find(".ulpc-note__open").click(function () {
				const helpId = $(this).parent().attr("data-id");
				$("#" + helpId).slideToggle();
			});
			calculator.find(".ulpc-note__close").click(function () {
				$(this).parent().slideUp();
			});
		}

		setCssVariables() {
			const calculator = $(this.element);
			const ulpc = this;
			calculator.each(function () {
				let calculatorColors = $(this).data("colors");
				let fontSize = $(this).data("font-size");
				document.documentElement.style.setProperty("--ulpc-font-size", fontSize);
				if (calculatorColors) {
					for (let key in calculatorColors) {
						let keyrgb = ulpc.convertColorHexToRgb(calculatorColors[key]);
						document.documentElement.style.setProperty("--ulpc-" + key, keyrgb);
					}
				}
			});
		}

		convertColorHexToRgb(color) {
			if (color.substring(0, 1) == "#") {
				color = color.substring(1);
			}

			// Ensure the color is 6 characters long
			if (color.length === 3) {
				color = color
					.split("")
					.map((c) => c + c)
					.join("");
			}

			let rgbColor;
			rgbColor = parseInt(color.substring(0, 2), 16) + "," + parseInt(color.substring(2, 4), 16) + "," + parseInt(color.substring(4), 16);

			return rgbColor;
		}

		fixGutenbergBlock() {
			let calculatorReady = false;
			const ulpc = this;
			let calculatorReadyInterval = setInterval(function () {
				if (document.querySelector(ulpc.widgetClass)) {
					ulpc.setCssVariables();

					calculatorReady = true;
				}
				if (calculatorReady) {
					clearInterval(calculatorReadyInterval);
				}
			}, 500);
		}

		calculateTrimesterProgress(currentDate, startDate, endDate) {
			if (currentDate < startDate) return 0;
			if (currentDate > endDate) return 100;

			const totalDays = this.diffCalendarDays(endDate, startDate);
			const passedDays = this.diffCalendarDays(currentDate, startDate);

			return Math.round((passedDays / totalDays) * 100);
		}

		calculateOvulationDetails(lastPeriodDate, cycleLength, currentDate) {
			const cycles = [];
			let currentCycleStart = new Date(lastPeriodDate);

			// Calculate 6 cycles
			for (let i = 0; i < 6; i++) {
				const cycle = this.calculateCycleDetails(currentCycleStart, cycleLength);
				cycles.push(cycle);

				// Set start date for next cycle
				currentCycleStart = new Date(cycle.nextPeriodStart);
			}

			return {
				cycles: cycles,
				currentCycle: cycles[0],
				cycleLength: cycleLength,
			};
		}

		calculateCycleDetails(periodStart, cycleLength) {
			const fertileStart = new Date(periodStart);
			fertileStart.setDate(periodStart.getDate() + cycleLength - ULPC.PREGNANCY_DEFAULTS.OVULATION_OFFSET - 5); // 5 days before ovulation

			const ovulationDate = new Date(periodStart);
			ovulationDate.setDate(periodStart.getDate() + cycleLength - ULPC.PREGNANCY_DEFAULTS.OVULATION_OFFSET);

			const fertileEnd = new Date(ovulationDate);
			fertileEnd.setDate(ovulationDate.getDate() + 2); // 2 day after ovulation

			const nextPeriodStart = new Date(periodStart);
			nextPeriodStart.setDate(periodStart.getDate() + cycleLength);

			const pregnancyTestDate = new Date(nextPeriodStart);
			pregnancyTestDate.setDate(nextPeriodStart.getDate() + 1);

			const dueDate = new Date(ovulationDate);
			dueDate.setDate(ovulationDate.getDate() + ULPC.PREGNANCY_DEFAULTS.PREGNANCY_FROM_OVULATION);

			return {
				periodStart: periodStart,
				fertileWindowStart: fertileStart,
				fertileWindowEnd: fertileEnd,
				ovulationDate: ovulationDate,
				pregnancyTestDate: pregnancyTestDate,
				nextPeriodStart: nextPeriodStart,
				estimatedDueDate: dueDate,
			};
		}

		displayTrimesterInfo(result) {
			let html = `<div class="ulpc-result__trimester-timeline">`;
			html += `<div class="ulpc-timeline">`;

			// Timeline visualization
			html += `<div class="ulpc-timeline__visualization">`;

			// First trimester
			html += `
				<div class="ulpc-timeline__segment ${result.currentTrimester === 1 ? "active" : ""}">
					<div class="ulpc-timeline__label">First Trimester</div>
					<div class="ulpc-timeline__progress-wrapper">
						<div class="ulpc-timeline__progress" 
							 style="width: ${result.currentTrimester === 1 ? result.trimesters.first.progress : result.currentTrimester > 1 ? "100" : "0"}%">
						</div>
					</div>
				</div>
			`;

			// Second trimester
			html += `
				<div class="ulpc-timeline__segment ${result.currentTrimester === 2 ? "active" : ""}">
					<div class="ulpc-timeline__label">Second Trimester</div>
					<div class="ulpc-timeline__progress-wrapper">
						<div class="ulpc-timeline__progress" 
							 style="width: ${result.currentTrimester === 2 ? result.trimesters.second.progress : result.currentTrimester > 2 ? "100" : "0"}%">
						</div>
					</div>
				</div>
			`;

			// Third trimester
			html += `
				<div class="ulpc-timeline__segment ${result.currentTrimester === 3 ? "active" : ""}">
					<div class="ulpc-timeline__label">Third Trimester</div>
					<div class="ulpc-timeline__progress-wrapper">
						<div class="ulpc-timeline__progress" 
							 style="width: ${result.currentTrimester === 3 ? result.trimesters.third.progress : "0"}%">
						</div>
					</div>
				</div>
			`;

			html += `</div>`; // Close visualization

			// Current week and total progress
			if (result.currentWeek) {
				const totalProgress = Math.round((result.currentWeek / 40) * 100);
				html += `
					<div class="ulpc-timeline__progress-info">
						<div class="ulpc-timeline__current">Current: Week ${result.currentWeek}</div>
						<div class="ulpc-timeline__total-progress">${totalProgress}% of pregnancy completed</div>
					</div>
				`;
			}

			// Trimester dates
			html += `<div class="ulpc-timeline__dates">
				<p>First Trimester: ${$.datepicker.formatDate(this.data.dateFormat, result.trimesters.first.start)} - ${$.datepicker.formatDate(this.data.dateFormat, result.trimesters.first.end)}</p>
				<p>Second Trimester: ${$.datepicker.formatDate(this.data.dateFormat, result.trimesters.second.start)} - ${$.datepicker.formatDate(this.data.dateFormat, result.trimesters.second.end)}</p>
				<p>Third Trimester: ${$.datepicker.formatDate(this.data.dateFormat, result.trimesters.third.start)} - ${$.datepicker.formatDate(this.data.dateFormat, result.trimesters.third.end)}</p>
			</div>`;

			html += `</div>`; // Close timeline container
			html += `</div>`; // Close trimester timeline container

			return html;
		}

		static initAll() {
			$(".ultimate-pregnancy-ovulation-calculator").each(function () {
				const calculator = new ULPC(this);
				calculator.init();
			});
		}

		// Prepares results for PHP transmission, ensuring proper date serialization
		prepareResultForPHP(result) {
			const preparedResult = JSON.parse(JSON.stringify(result));
			const dateFormat = this.data.dateFormat;

			// Function to process dates in the object
			const processObject = (obj) => {
				for (const key in obj) {
					// Check if the value is a string that looks like an ISO date
					if (typeof obj[key] === "string" && obj[key].match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/)) {
						// Convert ISO string to Date and format it
						const date = new Date(obj[key]);
						obj[key] = $.datepicker.formatDate(dateFormat, date);
					}
					// Check if the value is a Date object
					else if (obj[key] instanceof Date || Object.prototype.toString.call(obj[key]) === "[object Date]") {
						// Format the date
						obj[key] = $.datepicker.formatDate(dateFormat, obj[key]);
					}
					// Ensure boolean values are preserved
					else if (typeof obj[key] === "boolean") {
						// Keep boolean values as is
						obj[key] = obj[key];
					}
					// Recursively process nested objects
					else if (typeof obj[key] === "object" && obj[key] !== null) {
						processObject(obj[key]);
					}
				}
			};

			processObject(preparedResult);

			// Ensure futurePregnancy is explicitly set if it exists
			if (preparedResult.futurePregnancy === true) {
				preparedResult.futurePregnancy = true;
			}

			return preparedResult;
		}
	}

	// Initialize all calculators on page
	$(document).ready(function () {
		ULPC.initAll();
	});
})(jQuery);
